import { useCallback } from "react";
import classnames from "classnames";
import CardArtwork from "@/components/Card/CardArtwork";
import { FavoriteButton } from "@/components/Buttons/index";
import styles from "@/styles/Row.module.scss";
import routes from "@/lib/routes";
import VersatileLink from "@/components/VersatileLink";
import isShowValuePlanLabel from "@/lib/isShowValuePlanLabel";

export default function TVShowListCard({ item }) {
  const channelId = Number(item?.channel?.id);
  const showValuePlanLabel = isShowValuePlanLabel({ channelId });

  const handleClick = useCallback(
    (e) => {
      if (!item.isAllowedRating) {
        e.preventDefault();
      }
    },
    [item]
  );

  return (
    <div
      className={classnames(styles.container, styles.list, {
        [styles.notAllowed]: !item.isAllowedRating,
      })}
    >
      <div className={styles.inner}>
        <div className={styles.artwork}>
          <CardArtwork
            item={item}
            styles={styles.artworkInner}
            href={routes.titleWithRtsid(item)}
            linkAttr={{ onClick: handleClick }}
            showValuePlanLabel={showValuePlanLabel}
          />
        </div>
        <div className={styles.info}>
          <h4 className={styles.title}>
            <VersatileLink
              onClick={handleClick}
              href={routes.titleWithRtsid(item)}
            >
              {item.name}
            </VersatileLink>
          </h4>
          <div className={styles.episodes}>
            <div className={styles.tags}>
              <span>{item.genres.map((genre) => genre.name).join("/")}</span>
            </div>
          </div>
          <p className={styles.description}>{item.description}</p>
        </div>
        <div>
          <FavoriteButton listRow metaId={item.id} />
        </div>
      </div>
    </div>
  );
}
